import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { PRODUCT_LINE_PRICING_FRAGMENT } from 'graphql/fragments/product-line-pricing';
import { CUSTOM_LINE_PRICING_FRAGMENT } from 'graphql/fragments/custom-line-pricing';
import { QUOTE_PRICING_FRAGMENT } from 'graphql/fragments/quote-pricing';
import { QUOTE_PRICING_STATE_FRAGMENT } from 'graphql/fragments/quote-pricing-state';
import { Mutation as RootMutation } from 'graphql/models/generated';

export const ENSURE_OFFER_PRICES_UPDATED_MUTATION = gql`
mutation ensureOfferPricesUpdated(
  $documentVersion: DocumentVersionInput!,
  $withPricing: Boolean = true
  ) {
  quotes {
    ensurePricesUpdated(documentVersion: $documentVersion) {
      documentId
      revision
      locked
      createdByType
      lines @include(if: $withPricing) {
        id
        ...ProductLinePricingFragment
        ...CustomLinePricingFragment
      }
      ...QuotePricingFragment @include(if: $withPricing)
      ...QuotePricingStateFragment @skip(if: $withPricing)
    }
  }
}
${PRODUCT_LINE_PRICING_FRAGMENT}
${CUSTOM_LINE_PRICING_FRAGMENT}
${QUOTE_PRICING_FRAGMENT}
${QUOTE_PRICING_STATE_FRAGMENT}
`;

@Injectable({
  providedIn: 'root'
})
export class EnsureOfferPricesUpdatedMutation extends Mutation<RootMutation> {
  document = ENSURE_OFFER_PRICES_UPDATED_MUTATION;
}
